import { PlanJour } from "./plan-jour.model";

export class PlanSemaine {
    constructor(numSemaine: number) {
        this.numSemaine = numSemaine;
    }

    public numSemaine: number;
    public listeJours: PlanJour[] = [];

    get nbJoursSemaine(): number {
        return this.listeJours.length;
    }
}